
<template>
  <div>
    <template v-for="dialogOptions in dialogs">
      <v-dialog 
        @update:returnValue="dialogOptions.dialogRef.close()"
        :ref="dialogOptions.id"
        :key="dialogOptions.id"
        :full-width="dialogOptions.fullWidth"
        :lazy="true" 
        :persistent="dialogOptions.persistent"
        :max-width="dialogOptions.maxWidth"
        :width="dialogOptions.width"
        :scrollable="true" 
        transition="slide-y-reverse-transition"
        v-model="dialogOptions.active">
        <!-- <conditional-wrapper 
          tag="keep-alive" 
          :to-wrap="dialogOptions.keepAlive"> -->
        <component 
          :ref="dialogOptions.compId"
          :is="dialogOptions.component" 
          v-bind="dialogOptions.props">
          <div 
            slot="header" 
            slot-scope="headerProps">
            <v-toolbar 
              dark 
              class="elevation-1"
              color="primary">
              <v-toolbar-title class="white--text">{{ headerProps.title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip 
                :close-delay="0" 
                bottom>
                <template v-slot:activator="{ on }">
                <v-btn 
                  v-on="on"
                  @click="dialogOptions.dialogRef.close()" 
                  icon>
                  <v-icon>close</v-icon>
                </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>              
            </v-toolbar>
          </div>
        </component>
        <!-- </conditional-wrapper> -->
      </v-dialog>
    </template>
  </div>
</template>

<style scoped>
</style>

<script>
import sDialogComponent from "./sDialog.ts";
export default sDialogComponent;
</script>
